import React from 'react';

import { TrackingStatusEnum, TrackingStatus } from '@ael/core-api';
import { Guid } from '@ael/core-api';

type RenderCallback = (trackingStatus: TrackingStatus) => React.ReactElement;

interface ExternalProps {
  itemId: Guid;
  render: RenderCallback;
}

// Used to render student menu in Manager view
export const FakeTrackingStatusProvider: React.FC<ExternalProps> = React.memo(({ render }) => {
  const result = TrackingStatusEnum.Unknown;
  return render(result);
});

FakeTrackingStatusProvider.displayName = 'FakeTrackingStatusProvider';
